import { HeartHandshake } from "lucide-react";

import { StatusBadge } from "../../components/StatusBadge";
import { caregiversApi } from "../../api/directory";
import { DirectoryListPage } from "./DirectoryListPage";
import { CAREGIVER_STATUSES } from "./statuses";

const COLUMNS = [
  { key: "full_name", header: "Name", render: (row) => <strong>{row.full_name}</strong> },
  {
    key: "status",
    header: "Status",
    render: (row) => <StatusBadge statuses={CAREGIVER_STATUSES} value={row.status} />,
  },
  { key: "phone", header: "Phone", render: (row) => row.phone || "—" },
  { key: "email", header: "Email", render: (row) => row.email || "—" },
  { key: "city", header: "City", render: (row) => row.city || "—" },
];

export function CaregiversPage() {
  return (
    <DirectoryListPage
      title="Caregivers"
      description="The care workers on your agency's roster."
      resource={caregiversApi}
      statuses={CAREGIVER_STATUSES}
      columns={COLUMNS}
      basePath="/caregivers"
      addLabel="Add caregiver"
      searchPlaceholder="Search caregivers"
      emptyMessage="No caregivers yet. Add your first one to get started."
      emptyIcon={HeartHandshake}
      emptyTone="emerald"
    />
  );
}
